import { render, staticRenderFns } from "./personCategoryReduction.vue?vue&type=template&id=1f6c0deb&scoped=true"
import script from "./personCategoryReduction.vue?vue&type=script&lang=js"
export * from "./personCategoryReduction.vue?vue&type=script&lang=js"
import style0 from "./personCategoryReduction.vue?vue&type=style&index=0&id=1f6c0deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c0deb",
  null
  
)

export default component.exports